import { FilterDocument, GroupByMode, GroupSettings } from '@griply/types';
import { startOfDay, subDays } from 'date-fns';
import React, { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

import { COMPLETED_LOOKBACK_DAYS } from '../../constants';

const emptyOrder = {};

export type TasksOverviewProps = {
  scrollElement?: React.RefObject<HTMLDivElement>;
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
  defaultFilter: FilterDocument;
};

export const TasksOverview: React.FC<TasksOverviewProps> = ({
  scrollElement,
  filterDocument,
  setFilterDocument,
  defaultFilter,
}) => {
  const today = useToday();

  const onSectionCollapse = (collapsedSections: string[]) => {
    setFilterDocument((prev) => ({
      ...prev,
      collapsedSections,
    }));
  };

  const onReset = () => setFilterDocument(defaultFilter);

  const groupSettings = useMemo<GroupSettings>(
    () => ({
      [GroupByMode.CompletedDate]: {
        showRepeatingAsTodo: true,
        // Match the Firestore-side completion window so habit/repeating
        // occurrences (which are derived from each task's full schedule
        // history) don't extend further back than the regular tasks.
        completedFromDate: startOfDay(subDays(today, COMPLETED_LOOKBACK_DAYS)),
      },
    }),
    [today],
  );

  return (
    <ProvidedTaskFilterList
      filterDocument={filterDocument}
      defaultFilterDocument={defaultFilter}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      onReset={onReset}
      customOrder={emptyOrder}
      groupSettings={groupSettings}
    />
  );
};
